import React, { useContext, useEffect, useRef, useState } from "react";

import { ButtonGroup, Tab, Tabs } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import Table from "react-bootstrap/Table";

import { FileEarmarkPdf, FiletypeCsv } from 'react-bootstrap-icons';

import { CSVLink } from 'react-csv';

import {
  ATRIBUTOS_FILTRO_RELATORIO_ROES_CSV,
  ATRIBUTOS_FILTRO_TELA_ROES
} from "../utils/Constants";
import telaTabelaCabecalho from './relatorios/TelaTabelaCabecalho';
import comparativoPdf from './relatorios/sinteticoPdf';

import { Justify, Search, SortDown, SortUp } from "react-bootstrap-icons";

import { useNavigate } from "react-router-dom";
import { api } from "../../../services/Api";
import { AuthContext } from '../../../store/AuthContext';
import { dataAtualFormatada, dateTimeStringToISOFormat, horaAtualFormatada, montaMenssagemRetornoErroPromiseAllSettled } from "../../../util/FuncoesComuns";
import { AlertaExpedicaoContext } from "../contextsAlerta/AlertaExpedicao";
import ITable from "../interfaces/ITable";
import { aplicarFiltro } from "../utils/Filtros";
import { Mensagem } from "../utils/mensagem";
import "./index.css";
import { downloadBase64PDF } from "../utils/FuncoesPDF";

interface Props {
  linkClicado: (key: any) => void;
  isLinkClicado: (key: any) => boolean;
}

const RelatorioAlertaExcluido = ({ linkClicado, isLinkClicado }: Props) => {

  const navigate = useNavigate()
  const { user, setErro } = useContext(AuthContext);
  const divTable = useRef<null | HTMLInputElement>(null);
  const [, setMensagem] = useState<Mensagem>({ delay: 5000, tipo: '', texto: '', url: '/alerta-expedicao' });
  const [columns, setColumns] = useState<ITable[]>([]);
  const [filtro, setFiltro] = useState<string>('');
  const [ , setLinhaClicada] = useState("")
  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");
  const [listaRelatorioAlertaExcluido, setListaRelatorioAlertaExcluido] = useState<any[]>([]);
  const [listaRelatorioAlertaExcluidoFiltrada, setListaRelatorioAlertaExcluidoFiltrada] = useState<any[]>([]);
  const [, setShowToast] = useState<boolean>(false);
  const [keyTabRelatorioAlertaExcluido, setKeyTabRelatorioAlertaExcluido] = useState<string>('recebidos');

  const {
    key,
    setShowSpinner,
    dataSelecionada, setDataSelecionada,
  } = useContext(AlertaExpedicaoContext);

  useEffect(() => {
    setShowSpinner(() => true)
    if (key === 'roes') {
      setColumns(telaTabelaCabecalho());
      consultarListaRelatorioAlertaExcluido();
    }

    if (key === 'roes') setDataSelecionada(() => '1900-01-01');
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key,keyTabRelatorioAlertaExcluido])

  const consultarListaRelatorioAlertaExcluido = () => {

    (async function () {

      setShowSpinner(() => true);
      const [resLista] = await Promise.allSettled([api.get(`/v1/relatorio-alerta-excluido/roes-enviados-ou-recebidos?codSro=${user?.unidadeSro?.codigoSro}&dataRelatorio=${dataSelecionada}&isRelatorioEnviado=${keyTabRelatorioAlertaExcluido === 'enviados'}`)]);

      if (resLista.status === 'fulfilled') {
        let res = await resLista.value.data;
        setListaRelatorioAlertaExcluido(() => res);
        setListaRelatorioAlertaExcluidoFiltrada(() => res)
        setMensagem({ delay: 2000, tipo: 'info', texto: `Ok : Consulta realizada com sucesso.`, url: '/alerta-expedicao' });
        setShowToast(true);
      } else if (resLista.status === 'rejected') {
        setErro({ delay: 5000, tipo: 'danger', texto: montaMenssagemRetornoErroPromiseAllSettled(resLista, 'Erro ao chamar /v1/relatorio-alerta-excluido - Rejeitado.'), url: '/erro' });
        navigate('/erro')
      } else {
        setErro({ delay: 5000, tipo: 'warning', texto: `Alerta : Erro ao chamar /v1/relatorio-alerta-excluido - Outros.`, url: '/erro' });
        navigate('/erro')
      }
      setShowSpinner(() => false);
    })();

  };

  const setFiltroInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    setFiltro(event.target.value)
    if (event.target.value && event.target.value !== '' && event.target.value.length > 1) {
      let res: any = aplicarFiltro(listaRelatorioAlertaExcluido, ATRIBUTOS_FILTRO_TELA_ROES, event.target.value);
      setListaRelatorioAlertaExcluidoFiltrada(res);
    } else {
      setListaRelatorioAlertaExcluidoFiltrada(listaRelatorioAlertaExcluido)
    }
  }

  const handleSortingChange = (accessor: string) => {
    const sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);
    handleSorting(accessor, sortOrder);
  }

  const execute = (e: any, data: any, i: number, linha: string) => {
    e.preventDefault();
    setLinhaClicada(linha);

    (async function () {

      setShowSpinner(() => true);
      let resLista;
      if(data.nomeUsuarioDestino || data.codSroUnidadeNotificada !== user?.unidadeSro?.codigoSro){
        const [resListaC] = await Promise.allSettled([api.get(`/v1/relatorio-alerta-excluido/id/${data.id}`)]);
        resLista = resListaC;
      }else{
        const dataIniAno = dataAtualFormatada('ano', '-');
        const hora = horaAtualFormatada();
        const put = { id: data.id, matriculaUsuarioDestino: user.sub, dtHrBaixadoDestino: `${dataIniAno}T${hora}` }
        const [resListaU] = await Promise.allSettled([api.put('/v1/relatorio-alerta-excluido', put)]);
        resLista = resListaU;
      }

      if (resLista.status === 'fulfilled') {
        let res = await resLista.value.data;

       /* let byte = Uint8Array.from(atob(res.pdfDocumento), c => c.charCodeAt(0));
        const url = window.URL.createObjectURL(new Blob([byte]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', data.nomeDocumento);
        document.body.appendChild(link);
        link.click();
        //Step 3: Clean up the temporary URL
        document.body.removeChild(link);
        URL.revokeObjectURL(url);*/
        downloadBase64PDF(data.nomeDocumento,res.pdfDocumento);
        setMensagem({ delay: 2000, tipo: 'info', texto: `Ok : Consulta realizada com sucesso.`, url: '/v1/relatorio-alerta-excluido' });
        setShowToast(true);
      } else if (resLista.status === 'rejected') {
        setErro({ delay: 5000, tipo: 'danger', texto: montaMenssagemRetornoErroPromiseAllSettled(resLista, 'Erro ao chamar /v1/relatorio-alerta-excluido - Rejeitado.'), url: '/erro' });
        navigate('/erro')
      } else {
        setErro({ delay: 5000, tipo: 'warning', texto: `Alerta : Erro ao chamar /v1/relatorio-alerta-excluido - Outros.`, url: '/erro' });
        navigate('/erro')
      }
      setShowSpinner(() => false);
    })();


  }

  const handleSorting = (sortField: string | number, sortOrder: string) => {
    if (sortField) {
      const sorted = [...listaRelatorioAlertaExcluidoFiltrada].sort((a, b) => {
        if ((a as Record<string, any>)[sortField] === null) return 1;
        if ((b as Record<string, any>)[sortField] === null) return -1;
        if ((a as Record<string, any>)[sortField] === null && (b as Record<string, any>)[sortField] === null) return 0;

        //Caso específico de data no formato dd/mm/aaaa faz este sort
        if (sortField === 'dataMaximaPrazoMinimo') {
          const data01011900 = '01/01/1900 00:00:00';
          let dataA = (a as Record<string, any>)[sortField];
          let dataB = (b as Record<string, any>)[sortField];
          dataA = dataA ? dataA : data01011900;
          dataB = dataB ? dataB : data01011900;
          return sortOrder === "asc" ? new Date(dateTimeStringToISOFormat(dataA.toString())).getTime() - new Date(dateTimeStringToISOFormat(dataB.toString())).getTime() : new Date(dateTimeStringToISOFormat(dataB.toString())).getTime() - new Date(dateTimeStringToISOFormat(dataA.toString())).getTime();
        } else {
          return (
            (a as Record<string, any>)[sortField].toString().localeCompare((b as Record<string, any>)[sortField].toString(), "pt-BR", {
              numeric: true,
            }) * (sortOrder === "asc" ? 1 : -1)
          );
        }
      });

      setListaRelatorioAlertaExcluidoFiltrada(sorted);
    }
  };

  const montarCabecalho = () => {

    let cab = columns.map(({ label, accessor, sortable, className }) => {
      const cl = sortable ? sortField === accessor && order === "asc"
        ? <SortUp className="icon-table-sortable" />
        : sortField === accessor && order === "desc"
          ? <SortDown className="icon-table-sortable" />
          : <Justify className="icon-table-sortable" />
        : "";

      return (
        <th
          key={accessor}
          className={`${sortable ? `${className} cursor-pointer` : `${className}`}`}
          onClick={sortable ? () => handleSortingChange(accessor) : undefined}
        >
          {cl}
          {label !== 'checkbox-cabecalho' ? label : <Form.Check type="checkbox" disabled={!listaRelatorioAlertaExcluidoFiltrada || listaRelatorioAlertaExcluidoFiltrada.length === 0} />}
        </th>
      );
    });
    return cab;
  }

  return (

    <>

      <Form className="border rounded p-2 mb-3">

        <Form.Group as={Row} controlId="formlistaRelatorioAlertaExcluido">

          <Col sm={12} lg={6} xl={3}>
            <Form.Control
              type="search"
              placeholder="Filtrar"
              title="Digite algo para filtrar."
              disabled={!filtro && (!listaRelatorioAlertaExcluidoFiltrada || listaRelatorioAlertaExcluidoFiltrada.length === 0)}
              value={filtro}
              onChange={setFiltroInput}
            />
          </Col>
          <Col sm={12} lg={6} xl={3}>
            <InputGroup>
              <Form.Control
                type="date"
                placeholder="Selecione data"
                title="Selecione uma data para consultar."
                aria-describedby="basic-addon2"
                value={dataSelecionada && dataSelecionada !== '1900-01-01' ? dataSelecionada : ''} onChange={(e) => setDataSelecionada(e.target.value)}
              />
              <Button variant="primary" className="ps-1 py-0" id="button-addon2"
                title="Ao ser clicado consulta os unitizadores da data selecionada."
                disabled={!dataSelecionada}
                onClick={consultarListaRelatorioAlertaExcluido}>
                <Search className="icon-search" />
                Consultar
              </Button>
            </InputGroup>
          </Col>
          <Col sm={12} lg={12} xl={{ span: 3, offset: 3 }}>
            <ButtonGroup className='mb-2 w-100 h-100'>
              {listaRelatorioAlertaExcluidoFiltrada && listaRelatorioAlertaExcluidoFiltrada.length > 0 ?
                <CSVLink headers={ATRIBUTOS_FILTRO_RELATORIO_ROES_CSV} data={listaRelatorioAlertaExcluidoFiltrada} separator={';'} filename={"TelaROEs.csv"} className="btn btn-primary" type="button"><FiletypeCsv color='white' size={24} /> CSV</CSVLink>
                :
                <Button variant="primary" disabled={!listaRelatorioAlertaExcluidoFiltrada || listaRelatorioAlertaExcluidoFiltrada.length === 0}><FiletypeCsv color='white' size={24} /> CSV</Button>
              }
              <Button variant="primary" disabled={!listaRelatorioAlertaExcluidoFiltrada || listaRelatorioAlertaExcluidoFiltrada.length === 0} onClick={() => comparativoPdf(listaRelatorioAlertaExcluidoFiltrada, user, filtro, keyTabRelatorioAlertaExcluido)}><FileEarmarkPdf color='red' size={24} /> PDF</Button>
            </ButtonGroup>
          </Col>
        </Form.Group>

      </Form>

      <Row className="mx-0">
        <Col sm={12}>
          <Tabs id="tabsTipoRelatorioAlertaExcluido" defaultActiveKey="recebidos"
            activeKey={keyTabRelatorioAlertaExcluido}
            onSelect={(k) => setKeyTabRelatorioAlertaExcluido(k ? k : 'recebidos')}
            className="mb-3 fs-5">
            <Tab tabClassName="py-1" eventKey="recebidos" title="Recebidos" />
            <Tab tabClassName="py-1" eventKey="enviados" title="Enviados" />
          </Tabs>
        </Col>
      </Row>

      <div ref={divTable} className="mb-5 pb-4">
        <Table id="tabela-lista-expedicao-pendente" responsive striped className="scroll mb-0">
          <thead>
            <tr>
              {montarCabecalho()}
            </tr>
          </thead>
          {listaRelatorioAlertaExcluidoFiltrada && listaRelatorioAlertaExcluidoFiltrada.length > 0 ?

            (<tbody>
              {listaRelatorioAlertaExcluidoFiltrada.map((data: any, index: number) => {
                let i = ++index;

                return (

                  <tr id={String(index)} key={index}>
                    {columns.map(({ accessor, classNameData }) => {

                      return accessor !== "nomeDocumento" ? <td key={accessor} id={accessor} className={!classNameData || classNameData === "" ? "" : classNameData}>{(data as Record<string, any>)[accessor]}</td> : <td key={accessor} id={accessor} className={!classNameData || classNameData === "" ? "" : classNameData}><a onClick={(e) => execute(e, data, i, data.dtHrCriacao.replaceAll('/', '').replaceAll('-', '').replaceAll(' ', ''))} title={`Clique para gerar o arquivo PDF do Documento ${(data as Record<string, any>)[accessor]}.`} href="/alerta-expedicao" rel="noopener noreferrer"><strong>{(data as Record<string, any>)[accessor]}</strong></a></td>

                    })}
                  </tr>
                );
              })}
            </tbody>)

            :

            (<tbody><tr key={1}><td key={new Date().toLocaleTimeString()} colSpan={columns.length} className="text-center"><strong className="text-center">Não encontrou dados.</strong></td></tr></tbody>)
          }

        </Table>
      </div>

    </>
  )
}

export default RelatorioAlertaExcluido